import { use } from "react";

import type { OrgSelectionValue } from "./org-selection-context";

import { OrgSelectionContext } from "./org-selection-context";

/**
 * Access the current organization selection.
 *
 * @throws Error when used outside `OrgSelectionProvider`
 */
export const useOrgSelection = (): OrgSelectionValue => {
	const context = use(OrgSelectionContext);

	if (!context) {
		throw new Error(
			"useOrgSelection must be used within an OrgSelectionProvider",
		);
	}

	return context;
};
